import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "convergen.auth.token";

export function setAuthToken(token) {
  if (token) {
    try { localStorage.setItem(TOKEN_KEY, token); } catch (_) { /* storage disabled */ }
  } else {
    try { localStorage.removeItem(TOKEN_KEY); } catch (_) { /* storage disabled */ }
  }
}

export function getAuthToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch (_) { return ""; }
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer header as a fallback whenever a token is stored locally.
// The backend still prefers HttpOnly cookies; this header is only used when
// cookies are dropped (cross-site contexts, strict tracking blockers).
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Build a friendly error string from an axios error, surfacing the real
 * backend `detail`, status text, or network message instead of a generic
 * "Algo salió mal" that hides what truly failed.
 */
export function describeAxiosError(err, fallback = "Algo salió mal. Por favor intenta de nuevo.") {
  if (!err) return fallback;
  const detail = formatApiErrorDetail(err.response?.data?.detail);
  if (detail) return detail;
  if (err.response) {
    const status = err.response.status;
    if (status === 401) return "Credenciales inválidas.";
    if (status === 403) return "No tienes permiso para esta acción.";
    if (status >= 500) return `Error del servidor (${status}). Intenta más tarde.`;
    return `Error ${status}: ${err.response.statusText || "respuesta inválida"}.`;
  }
  if (err.message === "Network Error") {
    return "No hay conexión con el servidor. Verifica tu red e inténtalo de nuevo.";
  }
  return err.message || fallback;
}

export default api;
